/**
 * BrandMark · The Layer Mark, executed inline for pixel-perfect rendering
 * inside the product UI. Single solid bar above three separated blocks:
 * decision-intelligence layer above a fragmented stack.
 *
 * Variants:
 *   default   navy bar + slate blocks (light backgrounds — top bar, cards)
 *   reversed  white bar + slate blocks (dark backgrounds — slides, deck)
 *   tile      rounded navy tile with white bar + slate blocks (app icon, favicon)
 *   mono      single-color navy (one-color print contexts)
 */

const palettes = {
  default: { bar: "#1E3A5F", block: "#8FA1B8", tile: null, blockOpacity: 1 },
  reversed: { bar: "#FFFFFF", block: "#6E80A0", tile: null, blockOpacity: 1 },
  tile: { bar: "#FFFFFF", block: "#8FA1B8", tile: "#1E3A5F", blockOpacity: 1 },
  mono: { bar: "#1E3A5F", block: "#1E3A5F", tile: null, blockOpacity: 0.5 },
};

export default function BrandMark({
  size = 22,
  variant = "default",
  className = "",
  ...rest
}) {
  const p = palettes[variant] || palettes.default;
  const isTile = variant === "tile";

  // Non-tile geometry uses the full 96×96 canvas.
  // Tile geometry insets the mark inside a rounded navy background.
  const bar = isTile
    ? { x: 20, y: 22, w: 56, h: 14, rx: 3.5 }
    : { x: 6, y: 12, w: 84, h: 20, rx: 4.5 };
  const blockH = isTile ? 28 : 42;
  const blockY = isTile ? 44 : 42;
  const blockW = isTile ? 14 : 22;
  const blockRx = isTile ? 3 : 4.5;
  const blocksX = isTile ? [20, 41, 62] : [6, 37, 68];

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 96 96"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="ManufacturingOS"
      className={className}
      {...rest}
    >
      {p.tile && <rect width="96" height="96" rx="18" fill={p.tile} />}
      <rect
        x={bar.x}
        y={bar.y}
        width={bar.w}
        height={bar.h}
        rx={bar.rx}
        fill={p.bar}
      />
      {blocksX.map((x) => (
        <rect
          key={x}
          x={x}
          y={blockY}
          width={blockW}
          height={blockH}
          rx={blockRx}
          fill={p.block}
          fillOpacity={p.blockOpacity}
        />
      ))}
    </svg>
  );
}
